import { makeStyles } from '~/UIKit/Style';
import {
  VERTICAL_SEPARATOR,
  CHARCOAL_GREY,
  LIGHT_BLUE,
  WHITE,
  CHIP_COLOR_RED,
  GRAY_BACKGROUND,
} from '~/Constants/Colors.constants';
import { FONT_SIZE_LARGE, FONT_SIZE_SMALL } from '~/Constants/UI.constants';

const default_border = `thin solid ${VERTICAL_SEPARATOR}`;
const error_border = `thin solid ${CHIP_COLOR_RED}`;
export const ItemCreationSubsectionInputStyles = (conditions: {
  isAChild: boolean;
  icon: JSX.Element | undefined;
  noIconBackground?: boolean;
  disabled: boolean;
  hidden?: boolean;
  error: boolean;
  noBorder?: boolean;
}) =>
  makeStyles((theme) => ({
    ItemCreationSubsectionInputContainer: {
      backgroundColor: conditions.disabled ? GRAY_BACKGROUND : 'inherit',
      display: conditions.hidden ? 'none' : 'inherit',
      pointerEvents: conditions.disabled ? 'none' : 'initial',
      '&:first-of-type': {
        borderTop: conditions.noBorder ? 0 : default_border,
      },
    },
    ItemCreationSubsectionErrorLabel: {
      color: CHIP_COLOR_RED,
      fontSize: FONT_SIZE_SMALL,
      paddingLeft: 15,
    },
    ItemCreationSubsectionSingleInputContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      minHeight: 50,
      padding: '0 15px',
      position: 'relative',
      paddingLeft: conditions.isAChild ? 60 : 15,
      color: conditions.error ? CHIP_COLOR_RED : 'inherit',
      borderBottom: conditions.error ? error_border : default_border,
    },
    ItemCreationSubsectionInputIcon: {
      backgroundColor: conditions.isAChild || conditions.noIconBackground ? '' : LIGHT_BLUE,
      borderRadius: 16,
      minWidth: 32,
      maxWidth: 32,
      minHeight: 32,
      maxHeight: 32,
      lineHeight: '15px',
      fontSize: FONT_SIZE_LARGE,
      display: 'flex',
      alignItems: 'center',
      placeContent: 'center',
      marginRight: 15,
      color: CHARCOAL_GREY,
      '& > svg': {
        fontSize: 'inherit',
      },
    },
    ItemCreationSubsectionTypographyBody: {
      width: '100%',
      color: CHARCOAL_GREY,
    },
    ItemCreationSubsectionCustomElement: {
      [theme.breakpoints.down('md')]: {
        background: WHITE,
        borderTop: conditions.noBorder ? 0 : `thin solid ${VERTICAL_SEPARATOR}`,
        borderBottom: conditions.noBorder ? 0 : `thin solid ${VERTICAL_SEPARATOR}`,
        padding: conditions.noBorder ? 0 : 15,
      },
    },
    ItemCreationSubsectionLabelTooltip: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
  }));
